import React from "react";

type SidebarWidgetProps = {
  title: string;
  viewMore?: React.ReactNode | string;
  children: React.ReactNode;
  iconAbove?: HTMLOrSVGImageElement;
  iconAboveText?: string;
  onTipClick?: () => void;
};

const SidebarWidget = ({
  title,
  viewMore,
  iconAbove,
  iconAboveText,
  children,
  onTipClick,
}: SidebarWidgetProps) => {
  return (
    <div className="sidebar-widget">
      {iconAbove && (
        <div className="widget-icon">
          {iconAbove} <span>{iconAboveText}</span>
        </div>
      )}
      <div className="widget-title">
        <h2>{title}</h2>
        {viewMore && <>{viewMore}</>}
      </div>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { onTipClick }),
      )}
    </div>
  );
};

export default SidebarWidget;
